import { z } from 'zod';
import { RelativePeriodSchema } from '../period';

export const ComparisonSchema = z.object({
    kind: z.literal('time'),
    period: RelativePeriodSchema,
    mode: z.enum(['absolute', 'relative']),
});
